<template>
    <div class="sdf">
        <ul class="infinite-list" v-infinite-scroll="load" style="overflow:auto;;width:100%;height:200px;">
            <li v-for="i in this.$store.state.a.newWordList" class="infinite-list-item">{{ i }}</li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "WordPlanList",
        data () {
            return {
                count: 100
            }
        },
        methods: {
            load() {
                this.count += 2
            }
        }
    }
</script>

<style scoped>

    /*.sdf{*/
    /*    height: 100px;*/
    /*    position: relative;*/
    /*    background-color: red;*/
    /*    overflow: scroll;*/
    /*}*/
</style>